<template>
    <div class="app-container printBig">
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :label-width="'80px'" :col-span="colSpan" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData" @handleRadioChange="handleRadioChange">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.waveId')" prop="waveId">
              <BjInputNumber v-model="queryParams.waveId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.waveId')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.Status')" prop="Status">
              <BjSelectLov v-model="queryParams.status" :option-list="WAVE_STATUS_LIST" :placeholder="$t('screenWMS.Status')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.completion')">
              <BjDateRangePicker v-model="queryParamsTime_completionTime" :placeholder="$t('screenWMS.completion')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onPrint()">{{ $t('screenWMS.printPick') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'waveId'">
                  <span style="color: #3173d0;">{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onPrint(props.row)">{{ $t('screenWMS.Print') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { waveApi,orderApi } from '@/api';
    import { WAVE_STATUS_LIST, } from '@/utils/constants';
    import printJS from 'print-js';
    import JsBarcode from 'jsbarcode';

    export default {
      name: 'WMSWavePage',
      components: {},
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          WAVE_STATUS_LIST,
          queryApi: waveApi.getWaveList,
          // 查询参数
          queryParamsTime_completionTime: [],
          queryParams: {
            waveId: null,
            status: null,
            beginTime: null,
            endTime: null,
          },
          labelList: [
            { label: this.$t('screenWMS.waveId'), prop: 'waveId', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.Status'), prop: 'status', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.orderCount'), prop: 'orderCount', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.sortingStation'), prop: 'sortingStationName', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.creation'), prop: 'creationDate', isCheck: true, disabled: false },
            { label: this.$t('screenWMS.completion'), prop: 'completionTime', isCheck: true, disabled: false },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
          ],
          // 打印列表
          printList:[],
        };
      },
      watch: {
        queryParamsTime_completionTime(v) {
          this.queryParams.beginTime = (v || [])[0];
          this.queryParams.endTime = (v || [])[1];
        },
      },
      mounted() {},
      methods: {
        // 过滤页面数据
        afterFetchOriginalData(data) {
          data.content = data.records
          return data;
        },
        onView(row) {
          this.$router.push({
            name: 'WMSWaveDetail',
            query: { id: row.waveId },
          });
        },
        // 生成code128条形码
        generateBarcodeUrl(value, format = 'CODE128') {
          const canvas = document.createElement('canvas');
          JsBarcode(canvas, value, {
            format: format,
            lineColor: "#000",
            width: 2, // 调整条码线宽
            height: 50, // 调整条码高度
            fontSize: 14, // 调整字体大小
            textMargin: 5, // 调整文本边距
            margin: 10, // 调整整体边距
            fontOptions: 'bold',
            displayValue: true, // 显示条码下方的文本
          });
          return new Promise((resolve) => {
            canvas.toBlob(blob => {
              resolve(URL.createObjectURL(blob));
            }, 'image/png');
          });
        },
        // 打印json数据
        async onPrint(row){
          let POST_DATA = null
          if(row){
            POST_DATA = row.waveId
          }else{
            if(this.queryParams.waveId){
              POST_DATA = this.queryParams.waveId
            }else{
              return this.$message.warning(this.$t('screenWMS.ps5'))
            }
          }
          try {
            // 1. 生成条码 URL
            const barcodeUrl = await this.generateBarcodeUrl(POST_DATA);
            // 2. 获取打印数据
            const res = await orderApi.downPrintOrder({ waveId: POST_DATA });
            if (res.length) {
              this.printList = res;
              // 3. 显示打印预览（WaveID 和条码在同一行，表格充满 A4 宽度）
              this.$message.success(this.$t('screenWMS.ps3'));
              setTimeout(() => {
                // 创建一个打印容器
                const printContainer = document.createElement('div');
                printContainer.innerHTML = `
                  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
                    <span style="font-size: 16px; font-weight: bold;"> WaveID ： </span>
                    <img src="${barcodeUrl}" alt="WaveID" style="height: 50px;" />
                  </div>
                  <table border="1" style="width: 100%; border-collapse: collapse;">
                    <thead>
                      <tr>
                        <th style="border: 1px solid #303133; padding: 8px;">BIN</th>
                        <th style="border: 1px solid #303133; padding: 8px;">SKU</th>
                        <th style="border: 1px solid #303133; padding: 8px;">QTY</th>
                        <th style="border: 1px solid #303133; padding: 8px;">Barcode</th>
                        <th style="border: 1px solid #303133; padding: 8px;">Group</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${this.printList.map(item => `
                        <tr>
                          <td style="border: 1px solid #303133; padding: 8px;">${item.binlabel}</td>
                          <td style="border: 1px solid #303133; padding: 8px;">${item.sku}</td>
                          <td style="border: 1px solid #303133; padding: 8px;">${item.qty}</td>
                          <td style="border: 1px solid #303133; padding: 8px;">${item.barcode}</td>
                          <td style="border: 1px solid #303133; padding: 8px;">${item.groupName}</td>
                        </tr>
                      `).join('')}
                    </tbody>
                  </table>
                `;
                // 使用 printJS 打印
                printJS({
                  printable: printContainer,
                  type: 'html',
                  style: `
                    table { 
                      width: 100%; 
                      border-collapse: collapse; 
                    }
                    th, td { 
                      padding: 8px; 
                      border: 1px solid #303133; 
                      text-align: center; 
                    }
                    div { 
                      margin-bottom: 20px; 
                    }
                  `,
                });
              }, 1000);
            } else {
              this.$message.error(this.$t('screenWMS.ps4'));
            }
          } catch (error) {
            console.error("Error printing:", error);
          }
        },
        // 删除
        onDelete(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.delWaveList({id:row.waveId}).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
        beforeResetSearch() {
          this.queryParamsTime_completionTime = [];
          this.queryParams.waveId = null;
          this.queryParams.status = null;
          this.queryParams.completionTime = null;
          return new Promise(resolve => {
            resolve();
          });
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  .printBig{
    position: relative;
  }
  </style>
  